import { Button, Spin } from "antd";

const PDFViewerContent = ({ loading, loadingProgress, error, pdfBlobUrl, displayName, canvasRef, onRetry }) => {
  if (loading) return (
    <div className="pdf-loading-state">
      <Spin tip={`Loading PDF... ${loadingProgress > 0 ? loadingProgress + '%' : ''}`} size="large" />
      <div className="loading-text">
        Loading {displayName}
        {loadingProgress > 0 && (
          <div className="progress-bar-container">
            <div className="progress-bar">
              <div className="progress-bar-fill" style={{ width: `${loadingProgress}%` }} />
            </div>
          </div>
        )}
      </div>
    </div>
  );

  if (error) return (
    <div className="pdf-error-state">
      <div>❌ Failed to load PDF</div>
      <div style={{ marginTop: 8, fontSize: "14px" }}>{error}</div>
      <div style={{ marginTop: 8, fontSize: "12px", opacity: 0.7 }}>File: {displayName}</div>
      <Button onClick={onRetry} type="primary" className="retry-btn" style={{ marginTop: 16 }}>
        Retry Loading
      </Button>
    </div>
  );

  if (!pdfBlobUrl) return (
    <div className="pdf-error-state">
      <div>No PDF loaded</div>
      <div style={{ marginTop: 8, fontSize: "12px", opacity: 0.7 }}>File: {displayName}</div>
    </div>
  );

  return (
    <div className="pdf-viewer-wrapper">
      <canvas ref={canvasRef} />
    </div>
  );
};

const PDFViewerArea = (props) => (
  <div className="pdf-viewer-content">
    <PDFViewerContent {...props} />
  </div>
);

export default PDFViewerArea;